<!--公告及新闻稿-->
<template>
    <div ref="containerB">
      <transition name="moveing">
        <navgate-other ref="topTitle" v-show="isShowTopTitle"></navgate-other>
      </transition>
      
      <main class="index_main_content" ref="parentDiv">
        <div class="index_main_body other" ref="topDiv">
          <div class="zcgy_img"><img src="../../../assets/img/aboutus/about-banner.jpg"><div class="mask_bg"></div></div>
          <div class="zcgy_word">
            <div class="zcgy_ch">关于我们</div>
            <div class="zcgy_en">About Us</div>
          </div>
        </div>
        <!--二级导航定格-->
        <div class="second_nav_top" v-show="lockSecondTop" >
          <div class="second_nav_list">
            <div :class="{active_d:(selectedSecond == '公司简介')}" @click="gotoPoint('introduction','公司简介')">公司简介</div>
            <div :class="{active_d:(selectedSecond == '文化价值观')}" @click="gotoPoint('culture','文化价值观')">文化价值观</div>
            <div :class="{active_d:(selectedSecond == '大事记')}" @click="gotoPoint('bigThing','大事记')">大事记</div>
            <div :class="{active_d:(selectedSecond == '业务')}" @click="gotoPoint('business','业务')">业务</div>
            <div :class="{active_d:(selectedSecond == '领导团队')}" @click="gotoPoint('leader','领导团队')">领导团队</div>
            <div :class="{active_d:(selectedSecond == '廉洁平台')}" @click="gotoPoint('clear','廉洁平台')">廉洁平台</div>
          </div>
        </div>
        <!--二级导航-->
        <div class="second_nav" ref="secondNav">
          <div class="second_nav_list">
            <div :class="{active_d:(selectedSecond == '公司简介')}" @click="gotoPoint('introduction','公司简介')">公司简介</div>
            <div :class="{active_d:(selectedSecond == '文化价值观')}" @click="gotoPoint('culture','文化价值观')">文化价值观</div>
            <div :class="{active_d:(selectedSecond == '大事记')}" @click="gotoPoint('bigThing','大事记')">大事记</div>
            <div :class="{active_d:(selectedSecond == '业务')}" @click="gotoPoint('business','业务')">业务</div>
            <div :class="{active_d:(selectedSecond == '领导团队')}" @click="gotoPoint('leader','领导团队')">领导团队</div>
            <div :class="{active_d:(selectedSecond == '廉洁平台')}" @click="gotoPoint('clear','廉洁平台')">廉洁平台</div>
          </div>
        </div>
        <!--内容-->
        <div class="aboutus_body_box" ref="bodyMain">
          <!--公司简介-->
          <div class="about_jianjie_layout" ref="introduction">
            <div class="web_title">公司简介</div>
            <div>
              <img src="../../../assets/img/aboutus/jianjie1.jpg"></img>
              <div class="in-word">
                金山软件始创于1988年，是国内最早的互联网软件企业之一。历经30余载，目前主要涉及金山办公、西山居、金山世游、金山云等业务线。
                金山办公主要业务涉及WPS Office办公软件产品及服务的设计研发及销售推广；西山居及金山世游从事游戏研发及运营；
                金山云提供安全、可靠、稳定、高品质的云计算服务。
              </div>
              <img src="../../../assets/img/aboutus/jianjie2.jpg"></img>
              <div class="in-word">
                金山软件于2007年在香港主板上市。2011年全面转型移动互联网，全面实行 “All-in”战略布局。2019年金山办公在上交所科创板上市。
                2020年金山云在美国纳斯达克上市；2022年，金山云以介绍形式正式登陆港交所主板。
              </div>
              <img src="../../../assets/img/aboutus/jianjie3.jpg"></img>
              <div class="in-word">
                金山软件始终坚持“做世界一流的软件企业”的梦想，秉承“志存高远，脚踏实地”的理念，赢得了用户的信任，
                在北美、欧洲、日本及马来西亚等海外市场享有重要的市场份额。
              </div>
            </div>
          </div>
        <!--文化价值观-->
        <div class="wenhua_layout_box">
          <div class="about_wenhua_layout" ref="culture">
            <div class="web_title">文化价值观</div>
            <div class="wenhua_text_box">
              <div class="wenhua_content">
                <div class="wenhua_list">
                  <div class="wenhua_title">使命愿景</div>
                  <div class="wenhua_word">技术立业，服务社会。</div>
                </div>
                <div class="wenhua_list">
                  <div class="wenhua_title">志存高远 脚踏实地</div>
                  <div class="wenhua_word">志存高远，就是不管我们今天有多差，只要心中有梦想就有机会。脚踏实地，就是要忘我们曾经有多辉煌，从零开始，重刷Rom。</div>
                </div>
              </div>
              <div class="wenhua_content">
                <div class="wenhua_list">
                  <div class="wenhua_title">梦想</div>
                  <div class="wenhua_word">人因梦想而伟大</div>
                </div>
                <div class="wenhua_list">
                  <div class="wenhua_title">正直</div>
                  <div class="wenhua_word">人因正直而高贵</div>
                </div>
                <div class="wenhua_list">
                  <div class="wenhua_title">责任</div>
                  <div class="wenhua_word">人因责任而辉煌</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!--大事记-->
        <div class="about_dashi_layout" ref="bigThing">
          <div class="index_main_body dashi">
            <div class="zcgy_img"><img src="../../../assets/img/aboutus/dashi-banner.jpg"></div>
            <div class="zcgy_word">
              <div class="zcgy_ch">大事记</div>
              <div class="zcgy_en">金山30年，跌宕起伏，整整跨越了PC、互联网和移动互联网三个时代，是中国IT行业发展的剪影，<br>也是一部波澜壮阔的民族企业创业史。</div>
            </div>
          </div>
          <div class="about_dashi_lunbo">
            <div class="year_box">
              <swiper class="swiper" :options="swiperOptionYear">
                <swiper-slide v-for="(item,index) in timeLineList" :key="index"><div :class="swiperYearSelected==index?'yearlist check_year':'yearlist'">{{item.year}}</div></swiper-slide>
              </swiper>
            </div>
            <div class="lunbo_img_layout">
              <swiper  class="swiper gallery-top" :options="swiperOptionYearBottom" ref="swiperTop">
                <swiper-slide v-for="(item,index) in timeLineList" :key="index">
                  <div class="lunbo_img_box">
                    <img :src="item.titleImage">
                    <div class="lunbo_text">
                      {{item.title}}
                    </div>
                  </div>
                </swiper-slide>
                <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
              </swiper>
            </div>
          </div>
        </div>
        
        <!--业务-->
        <div class="about_yewu_layout" ref="business">
          <div class="yewu_box">
            <div class="web_title">业务</div>
            <div class="yewu_content">
              <swiper  class="swiper gallery-top" :options="swiperOptionBusiness" ref="swiperTop">
                <swiper-slide >
                  <div class="yewu_text_box">
                    <div class="introduction">
                      <div class="intro_logo"><img class="wpslogo" src="../../../assets/img/aboutus/wps-logo.png"></div>
                      <div class="intro_text">金山办公 ( 688111.SH )，是国内领先的办公软件和服务提供商，主要从事WPS Office办公软件产品及服务的设计研发及销售推广。</div>
                      <div class="more">更多信息请访问：<a href="https://www.wps.cn/" target="blank">https://www.wps.cn/</a></div>
                    </div>
                    <div class="introduction_img">
                      <img src="../../../assets/img/aboutus/WPS-2.jpg">
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide >
                  <div class="yewu_text_box">
                    <div class="introduction">
                      <div class="intro_logo"><img class="xsjlogo" src="../../../assets/img/aboutus/xishanju-logo.png"></div>
                      <div class="intro_text">国内最早的游戏开发公司之一，创作运营了超过数十款经典游戏，旗舰产品《剑侠情缘》系列已成功拓展至亚洲市场。同时，西山居在影视、动画、文学、戏剧、音乐、竞技赛事、文化周边不断跨界突破，全方位进军文创产业。</div>
                      <div class="more">更多信息请访问：<a href="https://www.xishanju.com/" target="blank">https://www.xishanju.com/</a></div>
                    </div>
                    <div class="introduction_img">
                      <img src="../../../assets/img/aboutus/xishanju-2.jpg">
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide >
                  <div class="yewu_text_box">
                    <div class="introduction">
                      <div class="intro_logo"><img class="sylogo" src="../../../assets/img/aboutus/shiyou-logo.png"></div>
                      <div class="intro_text">专注于网络游戏研发、全球发行运营、游戏投资等业务，以全新的理念与姿态展开战略规划与产品布局，业务范围辐射全球化大品类新兴市场。</div>
                    </div>
                    <div class="introduction_img">
                      <img src="../../../assets/img/aboutus/shiyou-2.jpg">
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide >
                  <div class="yewu_text_box">
                    <div class="introduction">
                      <div class="intro_logo"><img class="ksclogo" src="../../../assets/img/aboutus/ksc-logo.png"></div>
                      <div class="intro_text">金山云（股票代码：KC.NASDAQ；3896.HK），提供云计算基础架构和运营体系，并通过与物联网、区块链、边缘计算、大数据、AR/VR等技术结合，提供超过150种适用于视频、游戏、数字健康、金融、公共服务、社区、园区、教育、工业、电商零售等行业解决方案。</div>
                      <div class="more">更多信息请访问：<a href="https://www.ksyun.com/" target="blank">https://www.ksyun.com/</a></div>
                    </div>
                    <div class="introduction_img">
                      <img src="../../../assets/img/aboutus/KSC-2.jpg">
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide >
                  <div class="yewu_text_box">
                    <div class="introduction">
                      <div class="intro_logo"><img class="lblogo" src="../../../assets/img/aboutus/liebao-logo.png"></div>
                      <div class="intro_text">猎豹移动（NYSE:CMCM）成立于 2010 年 11 月，公司致力于“在人机共存的世界里，用科技让生活更美好”。2014 年 5 月 8 日，在纽交所正式上市。</div>
                      <div class="more">更多信息请访问：<a href="https://www.cmcm.com/" target="blank">https://www.cmcm.com/</a></div>
                    </div>
                    <div class="introduction_img">
                      <img src="../../../assets/img/aboutus/liebao-2.jpg">
                    </div>
                  </div>
                </swiper-slide>
                
              </swiper>
            </div>
            <div class="logo_btn">
              <img @click="imageSelected(0)" :class="swiperOneSelected == 0 ?'check':''" src="../../../assets/img/aboutus/wps-1.png">
              <img @click="imageSelected(1)" :class="swiperOneSelected == 1 ?'check':''" src="../../../assets/img/aboutus/xsj-1.png">
              <img @click="imageSelected(2)" :class="swiperOneSelected == 2 ?'check':''" src="../../../assets/img/aboutus/sy-1.png">
              <img @click="imageSelected(3)" :class="swiperOneSelected == 3 ?'check':''" src="../../../assets/img/aboutus/ksc-1.png">
              <img @click="imageSelected(4)" :class="swiperOneSelected == 4 ?'check':''" src="../../../assets/img/aboutus/cm-1.png">
            </div>
          </div>
        </div>
        <!--领导团队-->
        <div class="about_lingdao_layout" ref="leader">
          <div class="web_title">领导团队</div>
          <div class="dsh_list_box">
            <div class="dsh_img fr">
              <img class="img_1" src="../../../assets/img/aboutus/zoutao.jpg">
              <img class="img_2" src="../../../assets/img/aboutus/zoutao.jpg">
            </div>
            <div class="dsh_word_box fl">
              <div class="name">邹涛</div>
              <div class="zhiwei">执行董事及首席执行官</div>
              <div class="introduce">
                金山集团执行董事及首席执行官、金山办公董事长、金山云代理首席执行官。1998年加盟金山，负责开发金山词霸产品；2004年起负责公司的娱乐软件业务；2009年8月25日起担任公司执行董事。<br><br>
                2011年10月31日，成为金山软件副总裁兼金山游戏总裁，负责西山居整体管理，包括网络游戏研发，参与游戏业务决策制定；2016年12月1日继任金山集团CEO；2021 年担任金山办公董事长； 2022年，担任金山云首席执行官。
              </div>
            </div>
          </div>
          <!-- <div class="dsh_list_box">
            <div class="dsh_img fl">
              <img class="img_1" src="../../../assets/img/aboutus/guoweiwei.jpg">
              <img class="img_2" src="../../../assets/img/aboutus/guoweiwei.jpg">
            </div>
            <div class="dsh_word_box fr">
              <div class="name">郭炜炜</div>
              <div class="zhiwei">高级副总裁及西山居首席执行官</div>
              <div class="introduce">
                现任本集团高级副总裁兼Seasun Holdings Limited （「西山居」）首席执行官。彼于2004年加入西山居《剑侠情缘网络版三》（简称《剑网3》）项目组，目前担任剑网3系列制作人。郭先生熟悉西山居业务和发展战略，有着丰富的经营管理经验。郭先生毕业于美国Saint John's University。
              </div>
            </div>
          </div> -->
          <!--李翊隐藏
          <div class="dsh_list_box">
            <div class="dsh_img fr">
              <img class="img_1" src="../../../assets/img/aboutus/liyi.jpg">
              <img class="img_3" src="../../../assets/img/aboutus/liyi.jpg">
            </div>
            <div class="dsh_word_box fl">
              <div class="name">李翊</div>
              <div class="zhiwei">代理首席财务官兼副总裁</div>
              <div class="introduce">
                研究生学历，特许公认会计师公会会员，于2007年加入金山软件，担任集团财务部总监。<br><br>
                曾任职会计师事务所从事咨询及审计工作。在全面财务管理、投融资管理以及财务组织能力建设等方面均具有丰富的管理经验。
              </div>
            </div>
          </div>
          -->
          <div class="dsh_list_box">
            <div class="dsh_img fr">
              <img class="img_1" src="../../../assets/img/aboutus/zhaoyu.jpeg">
              <img class="img_3" src="../../../assets/img/aboutus/zhaoyu.jpeg">
            </div>
            <div class="dsh_word_box fl">
              <div class="name">赵宇</div>
              <div class="zhiwei">首席财务官</div>
              <div class="introduce">
                2026年6月加入金山软件。<br><br>
                赵宇加入金山软件前，曾于2019年5月至2026年4月担任联易融科技集团（一家于联交所上市的公司，股份代号：9959）的首席财务官。
                在加入联易融科技集团之前，他于2016年8月至2019年4月在腾讯集团投资并购部担任高级投资经理。
                在此之前，2010年至2014年期间，他先后任职于麦格理资本证券股份有限公司和德意志银行香港分行的投资银行部。<br><br>
                赵宇于2010年7月取得北京大学光华管理学院金融学学士学位，并于2016年6月取得麻省理工学院斯隆管理学院工商管理硕士学位。赵宇为特许金融分析师执照持有人。
              </div>
            </div>
          </div>
          <div class="dsh_list_box">
            <div class="dsh_img fl">
              <img class="img_1" src="../../../assets/img/aboutus/zhengke.jpg">
              <img class="img_2" src="../../../assets/img/aboutus/zhengke.jpg">
            </div>
            <div class="dsh_word_box fr">
              <div class="name">郑可</div>
              <div class="zhiwei">副总裁兼金山世游首席执行官</div>
              <div class="introduce">
                2004年3月加盟金山软件，历任项目主管、市场总监、西山居副总裁等职。2016年担任西山居世游首席执行官，2020年起担任金山世游首席执行官。<br><br>
                郑可毕业于成都信息工程大学，获得工学学士学位；2015年毕业于北大光华管理学院，获得工商管理硕士学位。
              </div>
            </div>
          </div>
          <div class="dsh_list_box">
            <div class="dsh_img fr">
              <img class="img_1" src="../../../assets/img/aboutus/gongdaojun.jpg">
              <img class="img_3" src="../../../assets/img/aboutus/gongdaojun.jpg">
            </div>
            <div class="dsh_word_box fl">
              <div class="name">龚道军</div>
              <div class="zhiwei">副总裁</div>
              <div class="introduce">
                2004年，毕业于湖南大学。<br>
                2004年，加入金山软件，历任金山网游事业部办公室主任、西山居副总裁。<br>
                2022年，任金山软件副总裁。<br>
                在金山任职期间，龚道军在游戏研运、跨界文娱、资本和企业运营积累深厚。2014年以来，完成了多个内外团队的投融资工作，投融资规模过亿元。
                2015年，推动西山居北美分公司成立，引擎技术迈向国际水平。2015年带领西山居剑侠系列移动版登陆越南市场，一度占据70%市场份额。
                2018年创立西山居文旅，推进游戏与实体娱乐跨界整合。2020年，西山居马来西亚、日本公司将国产网游推广到东南亚。
                西山居用户覆盖全球数十个国家和地区，全球月活用户超1007万。<br>
                2022年整合设立集团不动产中心，打造运营多个超20万平新型产业园，实现集团资产保值增值。
              </div>
            </div>
          </div>
          <div class="dsh_list_box">
            <div class="dsh_img fl">
              <img class="img_1" src="../../../assets/img/aboutus/sunhongyin.jpg">
              <img class="img_2" src="../../../assets/img/aboutus/sunhongyin.jpg">
            </div>
            <div class="dsh_word_box fr">
              <div class="name">孙红印</div>
              <div class="zhiwei">副总裁</div>
              <div class="introduce">
                1998年，毕业于中国农业大学。<br>
                1998年，加入金山，并参与开发金山词霸，金山快译等产品。<br>
                2004年，担任金山无线业务技术总监，负责开发金山词霸移动版本和无线增值业务。<br>
                2006年，担任大连鲸彩工作室副总经理，负责开发射击游戏《反恐行动》。<br>
                2009年，担任西山居副总经理，负责经典剑侠情缘端游业务。<br>
                2018年，担任西山居副总裁，负责业务管理部和经典剑侠端游项目，开发《剑网1归来》《剑侠世界3》和《剑侠世界起源》三款产品。<br>
                2023年，担任金山集团副总裁，负责组织干部和信息中心工作。
              </div>
            </div>
          </div>
        </div>

        <!--廉洁平台-->
        <div class="about_wenhua_layout" ref="clear">
          <div class="web_title">廉洁平台</div>
          <div class="lianjie_img">
            <img src="../../../assets/img/aboutus/lianjie.jpg">
          </div>
          <div class="lianjie_word_box">
            <div class="lianjie_email">官方举报邮箱 <a href="mailto:jubao@kingsoft.com">jubao@kingsoft.com</a></div>
            <div class="lianjie_word_1">
              金山软件集团致力于构建诚实守信、公平公正、公开透明的企业环境。我们要求每位员工在与各界合作伙伴开展业务过程中自觉遵守法律法规、尊重商业道德。
<br>我们绝不容忍任何腐败、贿赂等违反商业道德或相关法律法规的行为。如果您发现或怀疑集团员工涉嫌任何违规行为的，您可通过官方举报邮箱进行举报。
<br>我们严禁他人报复或惩罚任何善意的、就涉嫌违反法律法规或商业道德行为提供信息或协助调查的人士。
            </div>
            <div class="lianjie_word_2">我们主要受理以下类型的举报：</div>
            <div class="lianjie_word_2">
              1. 行贿、受贿、索贿；<br>
              2. 违规提供、收受礼品或款待；<br>
              3. 利益侵占、利用职权谋取私利的；<br>
              4. 虚假报销；<br>
              5. 利益冲突；<br>
              6. 财务舞弊；<br>
              7. 泄露、提供公司保密信息的。
            </div>
            <div class="lianjie_word_3">
              此举报邮箱仅适用于集团员工廉洁诚信问题的举报。若您希望提出一般金山产品、服务的业务咨询、投诉，请直接使用相关业务的查询或投诉途径，以便得到及时回应。
              <br><br>
              我们鼓励您实名举报，对举报情况属实且对集团有重大贡献的实名举报人或单位，我们会酌情给予奖励。我们承诺将严格保密举报人的有关信息。您也可选择匿名举报。
              <br><br>
              举报人应当对所举报事项的真实性负责。对于借举报捏造事实、诬告陷害的，集团保留对举报者采取法律或纪律处分的权利。
            </div>
          </div>
        </div>


      </div>
      </main>
      <footer-build @gotoBody="gotoBody"></footer-build>
    </div>
  </template>
  <script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  import UtilEvent from '../utils/UtilEvent.js'

    export default {
      name: 'aboutUs',
      components:{UtilEvent,Swiper, SwiperSlide},
      props: {
        
      },
      created(){
          
      },
      data () {
        let _self = this
        return {
          timeLineList:[
            {year:'1988',title:'金山软件成立，求伯君完成10万行代码，WPS1.0诞生',titleImage:require('../../../assets/img/aboutus/dashiji-1988.jpg')},
            {year:'1996',title:'发布国内第一款商业游戏《中关村启示录》',titleImage:require('../../../assets/img/aboutus/dashiji-1996.jpg')},  
            {year:'1999',title:'“红色风暴” 席卷全国',titleImage:require('../../../assets/img/aboutus/dashiji-1999.jpg')},
            {year:'2002',title:'蓝色安全革命',titleImage:require('../../../assets/img/aboutus/dashiji-2002.jpg')},
            {year:'2005',title:'《剑侠情缘》进入台湾、东南亚、越南，《金山毒霸》、WPS登陆日本',titleImage:require('../../../assets/img/aboutus/dashiji-2005.jpg')},
            {year:'2007',title:'金山软件在香港主板挂牌上市',titleImage:require('../../../assets/img/aboutus/dashiji-2007.jpg')},
            {year:'2011',title:'雷军出任董事长，强力推进整个集团全面转型移动互联网',titleImage:require('../../../assets/img/aboutus/dashiji-2011.jpg')},
            {year:'2014',title:'猎豹移动纽交所上市',titleImage:require('../../../assets/img/aboutus/dashiji-2014.jpg')},
            {year:'2017',title:'西山居与腾讯达成战略合作',titleImage:require('../../../assets/img/aboutus/dashiji-2017.jpg')},
            {year:'2019',title:'金山办公科创板上市',titleImage:require('../../../assets/img/aboutus/dashiji-2019.jpg')},
            {year:'2020',title:'金山云纳斯达克上市',titleImage:require('../../../assets/img/aboutus/dashiji-2020.jpg')},
            {year:'2021',title:'金山办公成为2022年冬奥会冬残奥会官方协同办公软件供应商',titleImage:require('../../../assets/img/aboutus/dashiji-2021.jpg')},
            {year:'2022',title:'《剑侠世界3》全平台公测',titleImage:require('../../../assets/img/aboutus/dashiji-2022.jpg')}
            
          ],
          _this:this,
          oldScrollTop:0,
          isShowTopTitle:true,
          showSecondTitle:false,
          lockSecondTop:false,
          topDivHeight:0,
          selectedSecond:'公司简介',
          swiperOneSelected:12,
          swiperYearSelected:12,
          swiperOne:null,
          swiperYear:null,
          swiperYearBottom:null,
          swiperOptionYear:{
            // simulateTouch : false,
            shortSwipes:false,
            slidesPerView: 10,
            slideToClickedSlide: true,
            spaceBetween: 2,
            centeredSlides: true,
            on:{
              init(){
                _self.initSliderYear(this)
              },
              slideChangeTransitionStart(){
                _self.slideChangeYear(this);
              },
              tap(){
                _self.yearClick(this);
              }
            },
            breakpoints: {
              1024: {
                slidesPerView: 10
                
              },
              768: {
                slidesPerView: 10
              },
              640: {
                slidesPerView: 6
              },
              320: {
                slidesPerView: 5
              }
            }
            
          },
          swiperOptionYearBottom:{
            speed:1000,
            spaceBetween: 10,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            on:{
              init(){
                _self.initSliderYearBottom(this)
              },
              slideChangeTransitionStart(){
                _self.slideChangeYearBottom(this);
              }
            }
          },
          swiperOptionTop: {
            loop: true,
            speed:1000,
            spaceBetween: 10,
            
            on:{
              init(){
                _self.initSlider(this)
              },
              slideChangeTransitionStart(){
                _self.slideChange(this);
              }
            }
            
          },
          swiperOptionBusiness: {
            loop: true,
            speed:1000,
            spaceBetween: 10,
            autoplay:true,
            on:{
              init(){
                _self.initSlider(this)
              },
              slideChangeTransitionStart(){
                _self.slideChange(this);
              }
            }
            
          },
          swiperOptionThumbs: {
            loop: false,
            speed:1000,
            loopedSlides: 6, // looped slides should be the same
            spaceBetween: 10,
            centeredSlides: true,
            freeMode:true,
            slidesPerView: 'auto',
            autoResize:true,
            touchRatio: 0.2,
            slideToClickedSlide: true
          }
        }
      },
      computed:{
        
      },
      methods:{
        gotoBody(){
            this.$refs.parentDiv.scrollIntoView({
                behavior: "smooth",  // 平滑过渡
            });
        },
        yearClick(swiper){
          this.swiperYearSelected = swiper.realIndex
        },
        //----年份区域
        initSliderYear(swiper){
          this.swiperYear = swiper;
          this.swiperYearSelected = 12;
          this.$nextTick(()=>{
            swiper.slideToLoop(12)
          })
          
        },
        slideChangeYear(swiper){
          this.swiperYearSelected = swiper.realIndex
          this.swiperYearBottom.slideToLoop(swiper.realIndex)
        },
        initSliderYearBottom(swiper){
          this.swiperYearBottom = swiper;
          this.swiperYearSelected = 12;
          this.$nextTick(()=>{
            swiper.slideToLoop(12)
          })
        },
        slideChangeYearBottom(swiper){
          this.swiperYearSelected = swiper.realIndex;
          this.swiperYear.slideToLoop(swiper.realIndex)
        },
        //---
        initSlider(swiper){
          this.swiperOne = swiper;
        },
        imageSelected(index){
          this.swiperOne.slideToLoop(index);
        },
        slideChange(swiper){
          
          this.swiperOneSelected = swiper.realIndex
        },
        gotoPoint(point,item){
          
          let offset = this.$refs[point].offsetTop;
          window.scrollTo({
              top:offset - 60,
              behavior: "smooth",  // 平滑过渡
          });
          setTimeout(()=>{
            this.selectedSecond = item;
          },1500)
          
        },
        scrolling(){
          //获取dom滚动距离
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
                      document.body.scrollTop;
          if(scrollTop >= this.topDivHeight){
            this.lockSecondTop = true;
          }else{
            this.lockSecondTop = false;
          }
          let scrollStep = scrollTop - this.oldScrollTop;
          this.oldScrollTop = scrollTop;
          if(!this.lockSecondTop){
            //scrollTop <= this.topDivHeight - 64 此距离是为了避免点击页签时候页面向上时候会把第一个导航漏出来
            if (scrollStep < 0 && (scrollTop <= this.topDivHeight - 64)) {
                this.isShowTopTitle = true;
            } else {
              if(scrollStep > 10){
                this.isShowTopTitle = false;
              }
            }
          }else{
            this.isShowTopTitle = false;
            this.handlerDivsListener();
          }
        },
        handlerDivsListener(){
          
          let arrayName = ["公司简介","文化价值观","大事记","业务","领导团队","廉洁平台"];
            let array = ["introduction","culture","bigThing","business","leader","clear"];
            let prePos = Math.abs(this.$refs[array[0]].getBoundingClientRect().top);
            this.selectedSecond = arrayName[0];
            for(let i = 1;i < array.length;i++ ){
              let temp = this.$refs[array[i]].getBoundingClientRect().top
              let offsetTop = Math.abs(temp);
              if((temp + 58 <= 0) && (offsetTop < prePos)){
                prePos = offsetTop;
                this.selectedSecond = arrayName[i];
              }
            }
          
        },
        clickSecondHandler(name){
          this.selectedSecond = name;
          
          this.$refs.secondNav.scrollIntoView({
              behavior: "smooth",  // 平滑过渡
          });
        }
        
      },
      watch:{
        
      },
      mounted(){
        //获得头部div高度
        this.topDivHeight = this.$refs.topDiv.offsetHeight;
        //刚加载页面后会有偏移量，便宜后再去监听
        setTimeout(()=>{
          window.addEventListener("scroll", this.scrolling)
        },300)

        // this.$nextTick(() => {
        //   const swiperTop = this.$refs.swiperTop.$swiper
        //   const swiperThumbs = this.$refs.swiperThumbs.$swiper
        //   swiperTop.controller.control = swiperThumbs
        //   swiperThumbs.controller.control = swiperTop
        // })
          
      },
      destroyed() {
        window.removeEventListener("scroll", this.scrolling);
      },
    }
    </script>
  
    <style lang="less">
    
    </style>